<template>
  <div class="authlist-import-container">
    <el-form class="edit-form" :model="formData" :rules="formRules" ref="form" label-position="top">
      <!-- <el-form-item label="项目" prop="projectCode">
        <el-select class="w-p-100" v-model="formData.projectCode" placeholder="请选择">
          <el-option
            v-for="item in projectList"
            :key="item.name"
            :label="item.value"
            :value="item.name"
          ></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item>
        <div class="import-box">
          <el-upload
            ref="upload"
            drag
            name="fileToUpload"
            class="upload-item"
            action=""
            :limit="1"
            :file-list="fileList"
            :on-change="handleFileChange"
            :before-upload="() => { return false }"
            :show-file-list="false"
          >
            <div class="upload-box">
              <i v-show="!curFile.name" class="el-icon-folder"></i>
              <span v-show="!curFile.name" class="guide-text">将表格文件拖到此处，或<span>点击上传</span></span>
              <span v-show="!curFile.name" class="limit-text">支持单个文件上传，支持文件格式：xls、xlsx，单个文件不能超过 10M</span>
              <span v-show="curFile.name" class="file-name">{{ curFile.name }}</span>
            </div>
          </el-upload>
        </div>
        <el-button class="primary-color" type="text" @click="handleDownMould">下载表格模板</el-button>
      </el-form-item>
      <div class="bottom-btn">
        <el-button class="submit-btn" @click="handleConfirm">确定</el-button>
        <el-button class="cancel-btn" @click="handleCancel">取消</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    projectList: {
      type: Array,
      default: () => ([]),
    },
    deviceType: {
      type: [String, Number]
    },
  },
  data() {
    return {
      curFile: {}, // 当前上传的文件
      resFileData: [], // 上传失败的文件数据
      formData: {
        // projectCode: ''
      },
      formRules: {
        // projectCode: [{ required: true, message: '项目不能为空', trigger: 'change' }],
      },
    }
  },
  methods: {
    ...mapActions(['upload']),
    // 处理文件上传前事件
    handleFileChange(file) {
      let fileType = file.name.split('.').pop()
      if (fileType != 'xlsx' && fileType != 'xls') {
        return this.$message.warning('只能上传xlsx或xls的excel文件')
      }
      let isSize = file.size / 1000 / 1024 < 10
      if (!isSize) {
        this.$refs.upload.clearFiles()
        return this.$message.warning('文件不能超过10M！')
      }
      
      this.curFile = file.raw
    },
    // 处理取消
    handleCancel() {
      this.curFile = {}
      this.$emit('close')
    },
    // 处理确认
    handleConfirm() {
      this.$refs.form.validate(v => {
        if (!v) {
          return this.$message.warning('请选择项目！')
        }
        if (!this.curFile.name) {
          return this.$message.warning('请上传文件！')
        }
        this.importFile()
      })
    },
    // 处理文件上传
    importFile() {
      let url = 'DEVICE.POST_UPLOAD_AUTH_EXCEL'
      let params = { fileToUpload: this.curFile }
      let postParams = {
        deviceType: this.deviceType,
        // projectCode: this.formData.projectCode
      }
      this.upload({ url, params, postParams, flag: true })
        .then(res => {
          if (res.code != 200) {
            return this.$message.error(res.msg || '导入失败！')
          }
          res = res.data || {}
          res.data = res.data || {}
          res.data.repeatCodeList = res.data.repeatCodeList || []
          res.data.exceptionCodeList = res.data.exceptionCodeList || []
          res.totalCount = res.totalCount || 0
          res.successCount = res.successCount || 0
          res.exceptionCount = res.exceptionCount || 0
          this.$refs.upload.clearFiles()

          if (res.data.repeatCodeList.length) {
            this.$message.warning('导入异常！存在重复数据！')
            this.$emit('show-repeat', res)
          } else if (res.data.exceptionCodeList.length) {
            this.$message.warning('导入异常！存在错误数据！')
            this.$emit('show-repeat', res)
          } else {
            this.$message.success('导入成功！')
            this.$emit('success')
          }

          this.curFile = {}
        })
        .catch(err => {
        })
    },
    // 处理模板下载
    handleDownMould() {
      let url = 'http://rwke.reconova.com:11033/dev/saas/resource/623aed430b7f0238d38bc05e.xls'
      if (this.deviceType === '104') { // 门铃
        url = 'http://rwke.reconova.com:11033/dev/saas/resource/623aecdc0b7f0238d38bc05d.xls'
      }
      window.open(url)
    },
  },
}
</script>

<style lang="less" scoped>
@mainColor: #303133;
@defaultColor: #909399;
@primaryColor: #409EFF;

.import-box {
  width: 100%;
  /deep/ .el-upload {
    width: 100%;
  }
  /deep/ .el-upload-dragger {
    width: 100%;
    .upload-box {
      height: 100%;
    }
  }
}
.upload-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  width: 100%;
  color: @mainColor;
  background-color: #F9F9F9;
  border: 1px dashed #DCDFE6;
  border-radius: 4px;
  &:hover {
    color: @primaryColor;
    border-color: @primaryColor;
    background-color: white;
    i {
      color: @primaryColor;
    }
  }
  i {
    font-size: 40px;
    color: @defaultColor;
  }
  .file-name {
    color: @primaryColor;
  }
  .guide-text {
    color: @mainColor;
    span {
      color: #409EFF;
    }
  }
  .limit-text {
    color: @defaultColor;
  }
}
.primary-color {
  color: @primaryColor;
}
.bottom-btn {
  padding-top: 10px;
  text-align: center;
  width: 100%;
}
</style>